export const STREAM_TIER = {
	"REGULAR_STREAM" : "0",
	"PRO_STREAM"     : "1",
	"MID_STREAM"     : "2"
};
